import React from 'react';

import {
  minValue,
  required,
  SelectInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import { DefaultThresholdInput } from './ThresholdInput';

import NumberInput from '../../layout/inputFields/NumberInput';

import Label from '../../../customFields/Label';

import { timePeriodChoices } from '../../../constants/timePeriods';
import TransactionTypeConfiguration from './TransactionTypeConfiguration';

const CashFlow = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <Grid size={12}>
        <Grid container spacing={1}>
          <Grid size={12}>
            <TransactionTypeConfiguration />
          </Grid>
          <Grid size={12}>
            <SelectInput
              source="ruleParameters.direction"
              label="Direction of cash flow"
              fullWidth
              choices={[
                {
                  id: 'incoming-outgoing', name: 'Incoming volume minus outgoing volume',
                },
                {
                  id: 'outgoing-incoming', name: 'Outgoing volume minus incoming volume',
                },
              ]}
            />
          </Grid>
          <Grid size={12}>
            <DefaultThresholdInput />
          </Grid>
          <Grid size={12}>
            <Label
              variant="label"
              title="Period"
              info="The period that the threshold will be checked against."
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <NumberInput
              source="ruleParameters.period.amount"
              fullWidth
              label="Length"
              validate={[required(), minValue(1)]}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <SelectInput
              source="ruleParameters.period.unit"
              choices={timePeriodChoices}
              fullWidth
              label="Period"
              validate={[required(), minValue(1)]}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>

);

export default CashFlow;
